module.exports = __webpack_public_path__ + "img/msi.f935e765.png";